<template>
  <v-row>
    <v-col cols="12">
      <v-card class="help-card" flat>
        <!-- HEADER BAND -->
        <div class="help-header pl-base-bg">
          <div class="help-header-icon">
            <v-icon color="#fff" size="22">mdi-help-circle-outline</v-icon>
          </div>
          <div>
            <div class="help-title">Help &amp; Guide</div>
            <div class="help-subtitle">मदद और गाइड</div>
          </div>
        </div>

        <div class="pa-6">
          <div class="help-flow-title">Your workflow, step by step / आपका वर्कफ़्लो, चरण दर चरण</div>

          <!-- STEPS -->
          <div v-for="(item, i) in items" :key="i" class="help-section mb-4">
            <div class="help-section-head">
              <div class="help-step-number">{{ i + 1 }}</div>
              <div class="section-title">
                {{ item.title }}
              </div>
            </div>

            <!-- 1. English -->
            <div class="section-text">
              {{ item.en }}
            </div>

            <!-- 2. Hindi -->
            <div class="section-text hindi">
              {{ item.hi }}
            </div>
          </div>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "HelpPage",
  data() {
    return {
      items: [
        {
          title: "Set up your Business Profile / बिज़नेस प्रोफ़ाइल सेट करें",
          en: "Start here. Add your business name, GSTIN (or just your state if you don't have one), address, and contact details — this is what appears at the top of every invoice you create.",
          hi: "यहाँ से शुरू करें। अपना बिज़नेस नाम, GSTIN (या अगर नहीं है तो सिर्फ़ राज्य), पता और संपर्क जानकारी जोड़ें — यही जानकारी हर इनवॉइस के ऊपर दिखती है।",
        },
        {
          title: "Add your Bank Account & Terms / बैंक खाता और नियम जोड़ें",
          en: "Add your bank account details so customers know where to pay, and set your Terms & Conditions once — both are pulled into every invoice PDF automatically, so you never have to re-type them.",
          hi: "बैंक खाता जोड़ें ताकि ग्राहक जान सकें कहाँ भुगतान करना है, और अपने नियम व शर्तें एक बार सेट करें — दोनों हर इनवॉइस PDF में अपने आप शामिल हो जाते हैं।",
        },
        {
          title: "Add your Customers / अपने ग्राहक जोड़ें",
          en: "Add each customer once with their name, address, and GSTIN (optional). When you create an invoice, just pick them from the list — no retyping their details every time.",
          hi: "हर ग्राहक को एक बार नाम, पता और GSTIN (वैकल्पिक) के साथ जोड़ें। इनवॉइस बनाते समय सूची से चुनें — हर बार दोबारा जानकारी लिखने की ज़रूरत नहीं।",
        },
        {
          title: "Add your Products / अपने प्रोडक्ट जोड़ें",
          en: "Add the products or services you sell, with price and HSN/SAC code. Turn on stock tracking if you want low-stock alerts — otherwise leave it off for pure services.",
          hi: "आप जो प्रोडक्ट या सेवाएं बेचते हैं उन्हें कीमत और HSN/SAC कोड के साथ जोड़ें। कम स्टॉक की चेतावनी चाहिए तो स्टॉक ट्रैकिंग चालू करें — सिर्फ़ सेवाओं के लिए इसे बंद रखें।",
        },
        {
          title: "Send a Quotation first, if needed / ज़रूरत हो तो पहले एक Quotation भेजें",
          en: "If a customer wants a price estimate before committing, create a Quotation instead of an invoice — same easy form, but it doesn't affect stock or your GST reports. Once they say yes, open it and click \"Convert to Invoice\" — it becomes a real invoice with a fresh number, ready to send.",
          hi: "अगर ग्राहक पक्का करने से पहले कीमत का अंदाज़ा चाहता है, तो इनवॉइस की जगह एक Quotation बनाएं — वही आसान फ़ॉर्म, लेकिन इससे स्टॉक या आपकी GST रिपोर्ट पर असर नहीं पड़ता। ग्राहक के हाँ कहने पर, इसे खोलें और \"Convert to Invoice\" पर क्लिक करें — यह नए नंबर के साथ असली इनवॉइस बन जाता है, भेजने के लिए तैयार।",
        },
        {
          title: "Create your first Invoice / अपना पहला इनवॉइस बनाएं",
          en: "Pick a customer and add items — GST (CGST+SGST or IGST) is calculated automatically based on your state and the customer's state. Preview the PDF live before saving.",
          hi: "ग्राहक चुनें और आइटम जोड़ें — GST (CGST+SGST या IGST) आपके और ग्राहक के राज्य के आधार पर अपने आप गणना हो जाता है। सेव करने से पहले PDF लाइव देखें।",
        },
        {
          title: "Send it — download or WhatsApp / भेजें — डाउनलोड या WhatsApp",
          en: "Download the invoice as a PDF, or share it straight to WhatsApp. On mobile, the actual PDF file is shared; on desktop, an instant link is sent instead.",
          hi: "इनवॉइस को PDF के रूप में डाउनलोड करें, या सीधे WhatsApp पर शेयर करें। मोबाइल पर असली PDF फ़ाइल शेयर होती है; डेस्कटॉप पर तुरंत लिंक भेजा जाता है।",
        },
        {
          title: "Get paid — full or partial / भुगतान पाएं — पूरा या आंशिक",
          en: "Mark an invoice as paid in full, or record a partial payment — the remaining balance stays as due, and every payment is automatically added to your Transactions.",
          hi: "इनवॉइस को पूरा भुगतान हुआ मार्क करें, या आंशिक भुगतान दर्ज करें — बाकी राशि बकाया रहती है, और हर भुगतान अपने आप ट्रांज़ैक्शन में जुड़ जाता है।",
        },
        {
          title: "Track everything / सब कुछ ट्रैक करें",
          en: "Paid invoices show up as income in Transactions automatically. Add expenses too (rent, supplies, etc.) for a complete picture. Check the Dashboard for a quick overview, and the P&L Report for detailed income/expense summaries.",
          hi: "भुगतान किए गए इनवॉइस अपने आप ट्रांज़ैक्शन में आय के रूप में दिखते हैं। खर्च भी जोड़ें (किराया, सामान आदि) पूरी तस्वीर के लिए। डैशबोर्ड पर त्वरित जानकारी और P&L रिपोर्ट में विस्तृत आय/खर्च सारांश देखें।",
        },
        {
          title: "Keep an eye on Due Invoices / बकाया इनवॉइस पर नज़र रखें",
          en: "Overdue invoices are highlighted in red on your Dashboard, so you always know who still owes you and when to follow up.",
          hi: "बकाया इनवॉइस डैशबोर्ड पर लाल रंग में दिखाई देते हैं, ताकि आपको हमेशा पता रहे कि किससे भुगतान लेना है और कब फॉलो-अप करना है।",
        },
        {
          title: "File your GST Reports (GSTR-1) / अपनी GST रिपोर्ट (GSTR-1) फाइल करें",
          en: "Go to GST Reports and pick a month or quarter to see your sales grouped exactly how GSTR-1 needs them: B2B (customers with a GSTIN), B2C Large (large unregistered sales to another state), B2C Small (everything else), an HSN-wise summary, and your total tax liability. Export to Excel (one sheet per section) or PDF and hand it to your accountant, or use it to file yourself. This tab covers your sales only — see the next step for the purchase/ITC side.",
          hi: "GST रिपोर्ट में जाएं और महीना या तिमाही चुनें — आपकी बिक्री बिल्कुल उसी तरह दिखेगी जैसी GSTR-1 के लिए चाहिए: B2B (जिन ग्राहकों के पास GSTIN है), B2C Large (दूसरे राज्य में बड़ी अनरजिस्टर्ड बिक्री), B2C Small (बाकी सभी), HSN-वार सारांश, और आपकी कुल टैक्स देनदारी। Excel (हर सेक्शन की अलग शीट) या PDF में एक्सपोर्ट करें और अपने अकाउंटेंट को दें, या खुद फाइल करने के लिए इस्तेमाल करें। यह टैब सिर्फ़ आपकी बिक्री दिखाता है — खरीद/ITC वाले हिस्से के लिए अगला चरण देखें।",
        },
        {
          title: "Track Vendors, Purchases & ITC / वेंडर, खरीद और ITC ट्रैक करें",
          en: "Add your suppliers under Vendors, and record each bill you receive under Purchases — with the same line-item, HSN, and tax-split detail your invoices already capture. Mark each line as ITC Eligible or not (most ordinary purchases are eligible; check with your accountant on exceptions like vehicles or personal expenses). The ITC Summary tab on GST Reports then shows your total eligible and blocked credit, plus an HSN-wise breakdown, using the same period filter as GSTR-1 — export it the same way, to Excel or PDF. This covers ordinary domestic purchases only, not reverse charge, imports, or ISD credit, and isn't a full GSTR-3B computation on its own.",
          hi: "अपने सप्लायर को Vendors में जोड़ें, और हर मिला हुआ बिल Purchases में दर्ज करें — बिल्कुल उसी लाइन-आइटम, HSN और टैक्स-स्प्लिट जानकारी के साथ जो आपके इनवॉइस में पहले से है। हर लाइन को ITC Eligible या नहीं मार्क करें (ज़्यादातर सामान्य खरीद योग्य होती हैं; वाहन या निजी खर्च जैसे अपवादों के लिए अपने अकाउंटेंट से पूछें)। GST रिपोर्ट में ITC Summary टैब फिर आपका कुल योग्य और ब्लॉक किया गया क्रेडिट, साथ ही HSN-वार विवरण दिखाता है — वही period फ़िल्टर इस्तेमाल करते हुए जो GSTR-1 में है — इसे भी Excel या PDF में एक्सपोर्ट करें। यह सिर्फ़ सामान्य घरेलू खरीद को कवर करता है, रिवर्स चार्ज, आयात, या ISD क्रेडिट को नहीं, और यह अपने आप में पूरा GSTR-3B कैलकुलेशन नहीं है।",
        },
        {
          title: "Issue Credit & Debit Notes / क्रेडिट और डेबिट नोट जारी करें",
          en: "Need to reduce what a customer owes — a return, a discount, a billing correction? Open the invoice and click \"Issue Credit Note.\" Need to reduce what you owe a vendor, or claw back ITC on a returned item? Open the purchase and click \"Issue Debit Note.\" Both pre-fill the original document's items so you just adjust down to what's actually being credited or debited, and both are automatically included in GST Reports — Credit Notes in GSTR-1's CDNR/CDNUR sections, Debit Notes as \"ITC Reversed\" in the ITC Summary tab, so your Net ITC Eligible figure always stays accurate.",
          hi: "किसी ग्राहक का बकाया कम करना है — रिटर्न, छूट, या बिलिंग सुधार? इनवॉइस खोलें और \"Issue Credit Note\" पर क्लिक करें। किसी वेंडर को दिया जाने वाला बकाया कम करना है, या लौटाए गए सामान पर ITC वापस लेना है? खरीद खोलें और \"Issue Debit Note\" पर क्लिक करें। दोनों मूल दस्तावेज़ के आइटम अपने आप भर देते हैं — आप बस उतना समायोजित करें जितना वाकई क्रेडिट या डेबिट किया जा रहा है, और दोनों अपने आप GST रिपोर्ट में शामिल हो जाते हैं — क्रेडिट नोट GSTR-1 के CDNR/CDNUR सेक्शन में, डेबिट नोट ITC Summary टैब में \"ITC Reversed\" के रूप में, ताकि आपका Net ITC Eligible आँकड़ा हमेशा सही रहे।",
        },
        {
          title: "See your proper double-entry ledger / अपना पूरा डबल-एंट्री बहीखाता देखें",
          en: "Behind the scenes, ProfitLedgex also keeps a full double-entry ledger — Chart of Accounts, Trial Balance, Balance Sheet, General Ledger, and a ledger-based Accrual P&L — all posted automatically from your invoices, purchases, and payments, with nothing to enter by hand. If you're switching from another system, use Opening Balances once to set your starting figures. These are extra tools for going deeper with your accountant — you don't need them for everyday billing.",
          hi: "पर्दे के पीछे, ProfitLedgex एक पूरा डबल-एंट्री बहीखाता भी रखता है — Chart of Accounts, Trial Balance, Balance Sheet, General Ledger, और ledger-आधारित Accrual P&L — जो आपके इनवॉइस, खरीद और भुगतान से अपने आप बन जाता है, कुछ भी हाथ से भरने की ज़रूरत नहीं। अगर आप किसी और सिस्टम से आ रहे हैं, तो Opening Balances का इस्तेमाल एक बार अपनी शुरुआती राशि सेट करने के लिए करें। ये अतिरिक्त टूल आपके अकाउंटेंट के साथ और गहराई से काम करने के लिए हैं — रोज़मर्रा की बिलिंग के लिए इनकी ज़रूरत नहीं।",
        },
        {
          title: "Match your ITC against GSTR-2A/2B / अपने ITC को GSTR-2A/2B से मिलाएं",
          en: "Download your GSTR-2A or 2B from the GST portal and import it under 2A/2B Reconciliation to check whether the credit you've claimed actually matches what your vendors filed. You'll see four clear buckets — Matched, Mismatched, Only in Books (credit at risk), and Only in Return (credit you haven't claimed yet) — so nothing slips through before you file.",
          hi: "GST पोर्टल से अपना GSTR-2A या 2B डाउनलोड करें और 2A/2B Reconciliation में इम्पोर्ट करें, यह जांचने के लिए कि आपने जो क्रेडिट क्लेम किया है वह वाकई आपके वेंडर की फाइलिंग से मेल खाता है या नहीं। आपको चार साफ़ ग्रुप दिखेंगे — Matched, Mismatched, Only in Books (जोखिम में क्रेडिट), और Only in Return (अभी तक क्लेम न किया गया क्रेडिट) — ताकि फाइल करने से पहले कुछ भी छूटे नहीं।",
        },
        {
          title: "Reconcile your bank statement / अपना बैंक स्टेटमेंट मिलाएं",
          en: "Import your bank statement (CSV or Excel) under Bank Reconciliation. ProfitLedgex automatically suggests matches against transactions you've already recorded — just confirm, match manually, or ignore lines like bank charges. You'll always see your Book Balance vs. Bank Balance and exactly what's left unmatched.",
          hi: "अपना बैंक स्टेटमेंट (CSV या Excel) Bank Reconciliation में इम्पोर्ट करें। ProfitLedgex पहले से दर्ज ट्रांज़ैक्शन के साथ अपने आप मैच सुझाता है — बस पुष्टि करें, खुद मैच करें, या बैंक चार्ज जैसी लाइनों को इग्नोर करें। आपको हमेशा Book Balance और Bank Balance, और जो अभी भी अनमैच्ड है वह साफ़ दिखेगा।",
        },
        {
          title: "Track Fixed Assets & depreciation / फिक्स्ड एसेट्स और डेप्रिसिएशन ट्रैक करें",
          en: "Own equipment, furniture, or vehicles? Add them under Fixed Assets with their cost and useful life, and run Depreciation whenever you like — ProfitLedgex posts straight-line depreciation to your ledger automatically, catching up any months you've missed in one click.",
          hi: "क्या आपके पास उपकरण, फर्नीचर, या वाहन हैं? उन्हें Fixed Assets में उनकी कीमत और उपयोगी जीवन के साथ जोड़ें, और जब चाहें Depreciation चलाएं — ProfitLedgex अपने आप स्ट्रेट-लाइन डेप्रिसिएशन आपके बहीखाते में पोस्ट कर देता है, एक क्लिक में छूटे हुए महीनों को भी पूरा कर देता है।",
        },
        {
          title: "Run Payroll for your staff / अपने स्टाफ के लिए Payroll चलाएं",
          en: "Add employees under Payroll with their gross salary and PF/TDS/PT figures (from your CA or payroll provider — ProfitLedgex doesn't calculate these by statutory rate). Each month, click Run Payroll to post everyone's salary to your ledger in one go — only once per month, so you never double-post.",
          hi: "Payroll में कर्मचारियों को उनके ग्रॉस सैलरी और PF/TDS/PT आँकड़ों के साथ जोड़ें (अपने CA या पेरोल प्रोवाइडर से — ProfitLedgex इन्हें सांविधिक दर से खुद नहीं निकालता)। हर महीने, Run Payroll पर क्लिक करें ताकि सबकी सैलरी एक साथ आपके बहीखाते में पोस्ट हो जाए — महीने में सिर्फ़ एक बार, ताकि दोबारा पोस्ट न हो।",
        },
        {
          title: "Bring your team onto ProfitLedgex / अपनी टीम को ProfitLedgex पर लाएं",
          en: "Need an accountant or staff member working in your books too? Go to Team Members (under Business) and invite them by email, choosing Full Access (can create/edit/delete, just like you) or View Only (can see everything, change nothing). Business Profile, Bank Account, and Terms & Conditions always stay owner-only, no matter what access you grant. You can change anyone's access, deactivate them, or remove them entirely at any time — and they never need their own subscription, since their access simply follows yours.",
          hi: "क्या आपको अकाउंटेंट या स्टाफ को भी अपने बहीखातों में काम करने देना है? Team Members (Business के अंदर) में जाएं और उन्हें ईमेल से आमंत्रित करें — Full Access (आपकी तरह बना/बदल/मिटा सकते हैं) या View Only (सब देख सकते हैं, कुछ बदल नहीं सकते) चुनें। Business Profile, Bank Account, और Terms & Conditions हमेशा सिर्फ़ मालिक के पास रहते हैं, चाहे जो भी एक्सेस दें। आप किसी का भी एक्सेस बदल सकते हैं, उन्हें निष्क्रिय कर सकते हैं, या पूरी तरह हटा सकते हैं — और उन्हें कभी अपनी अलग सब्सक्रिप्शन की ज़रूरत नहीं होती, क्योंकि उनका एक्सेस आपकी सब्सक्रिप्शन के साथ ही चलता है।",
        },
      ],
    };
  },
};
</script>

<style scoped>
.help-card {
  border-radius: 0;
  overflow: hidden;
  box-shadow: 0 6px 24px rgba(15, 30, 50, 0.1);
}

.help-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 20px;
}

.help-header-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.help-title {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.01em;
}

.help-subtitle {
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.75);
  margin-top: 2px;
}

.help-section {
  padding: 14px 18px;
  border-radius: 0;
  background: #f8fafc;
  border: 1px solid #eef1f5;
  border-left: 4px solid #0a5a90;
}

.help-flow-title {
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6b7280;
  margin-bottom: 16px;
}

.help-section-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}

.help-step-number {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #0a5a90;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.section-title {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
}

.section-text {
  font-size: 15px;
  line-height: 1.6;
  color: #374151;
}

.section-text.hindi {
  margin-top: 4px;
  color: #4b5563;
  font-size: 14px;
}
</style>
